import moment from "moment"
import { forwardRef } from "react"
import ReactDatePicker from "react-datepicker"
import styled from "styled-components"
import { defaultThemeColors, themeColor, themeFontSize } from "../../theme"

export const DatePicker = ({ date, setDate, format, labelSize, ...rest }) => {
    const CustomDateInputField = forwardRef(
        ({ value, onClick, className }, ref) => {
            const displayValue = value
                ? moment(new Date(value)).format(format || "MMM D")
                : "Select Date"
            return (
                <DateInputButton className={className} size={labelSize} onClick={onClick} ref={ref}>
                    <span>{displayValue}</span>
                </DateInputButton>
            )
        }
    )

    return (
        <DatePickerContainer>
            <ReactDatePicker
                {...rest}
                selected={date}
                onChange={(date) => setDate(date)}
                customInput={<CustomDateInputField />}
            />
        </DatePickerContainer>
    )
}

const DatePickerContainer = styled.div`
    border-width: 2px;
    border-style: solid;
    border-color: ${defaultThemeColors.lightBlue};
    border-radius: 8px;
    display: flex;
    width: 100%;

    & > .react-datepicker-wrapper {
        width: 100%;
    }
`

const DateInputButton = styled.button`
    all: unset;
    width: 100%;
    height: 39px;
    border-radius: 8px;
    background-color: ${({ bgColor = "white" }) => themeColor(bgColor)};
    color: ${themeColor("txt")};
    text-transform: capitalize;
    font-family: var(--font-secondary);
    font-size: ${({ size = "regular" }) => themeFontSize(size)};
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        opacity: 0.8;
    }
`
